import { useState } from 'react';
import { Switch, Text } from 'shell/components';

const SwitchDemo = () => {
    const [checked, setChecked] = useState(true);

    const handleChange = (event, newCheckedState) => {
        setChecked(newCheckedState);
    };

    return (
        <>
            <Text variant={'sh1'}>Switch</Text>
            <Text variant={'sh2'}>Uncontrolled Switch</Text>
            <Switch />
            <Text variant={'sh2'}>Controlled Switch</Text>
            <Switch checked={checked} onChange={handleChange} />
            <Text variant={'sh2'}>Disabled Switch</Text>
            <Switch disabled />
        </>
    );
};

export default SwitchDemo;
